import { isLabelsArrayOperator, isLabelsNameOperator } from '@ipfabric/utils';
import type { FC } from 'react';
import { LabelsFilterConstructor } from './LabelsFilterConstructor/LabelsFilterConstructor';
import { TextFilterRule } from './TextFilterRule';

type LabelsColumnFilterRuleProps = {
  hasError: boolean;
  onBlur: () => void;
  onValueChange: (value: string) => void;
  operator: string | null;
  value: string;
};

export const LabelsColumnFilterRule: FC<LabelsColumnFilterRuleProps> = (
  props,
) => {
  if (!isLabelsArrayOperator(props.operator)) {
    return (
      <TextFilterRule
        hasError={props.hasError}
        onBlur={props.onBlur}
        onValueChange={props.onValueChange}
        value={props.value}
      />
    );
  }

  return (
    <LabelsFilterConstructor
      mode={isLabelsNameOperator(props.operator) ? 'name' : 'exact'}
      onBlur={props.onBlur}
      onChange={props.onValueChange}
      value={props.value}
    />
  );
};
